module.exports = __webpack_public_path__ + "static/img/440.358.360.0aa12bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/440.358.360.jpg
// module id = 212
// module chunks = 1